<script lang="ts" setup>
import type {ResponseType} from "~/types/Task";
import ChatListItem from "~/components/pages/office/chat/ChatListItem.vue";
import { ScrollArea } from '~/components/ui/scroll-area'
import { vIntersectionObserver } from '@vueuse/components'

const props = defineProps({
    chats: {
        type: Array as PropType<ResponseType[]>,
        required: true,
    },
    isLoadingMore: {
        type: Boolean,
        default: false,
    },
    hasMore: {
        type: Boolean,
        default: false,
    }
})

const route = useRoute()
const emit = defineEmits(['selectChat', 'loadMore', 'setViewedMessages'])

const loadMoreTrigger = ref<HTMLElement | null>(null)

const handleIntersection = () => {
    if (props.hasMore && !props.isLoadingMore) {
        emit('loadMore')
    }
}
</script>

<template>
    <ScrollArea>
        <ChatListItem
                v-for="(chat, i) in chats"
                :key="chat.documentId"
                :chat="chat"
                :is-selected="route.name === 'office_chat' && route.params.id === chat.documentId"
                :class="{
                    '!border-b-0': i + 1 === chats.length || route.name === 'office_chat' && route.params.id === chat.documentId,
                }"
                @setViewedMessages="emit('setViewedMessages', chat.documentId)"
        />
        <div 
            v-if="hasMore"
            ref="loadMoreTrigger"
            v-intersection-observer="handleIntersection"
            class="flex justify-center items-center py-4"
        >
            <Icon 
                v-if="isLoadingMore" 
                name="svg-spinners:ring-resize" 
                size="24px" 
                class="text-gray-400" 
            />
        </div>
    </ScrollArea>
</template>